import { trackEvent } from '@raisin/events-tracking';
import { CUSTOMER_PORTAL_COMMON_EVENT_PROPERTIES, CUSTOMER_PORTAL_COMPONENT } from '../constants';
import { CustomerPortalEvent } from '../types';
import { getAuthValue, guardDistributorValue } from '../utils';
import { OnClickableCardsClickedEventProps } from './types';

const createClickableCardsClickedEvent = ({
  distributorId,
  isLoggedIn,
  targetUrl,
  pageUrl,
  card,
}: OnClickableCardsClickedEventProps): CustomerPortalEvent => ({
  ...CUSTOMER_PORTAL_COMMON_EVENT_PROPERTIES,
  eventName: 'card_clicked',
  object: 'card',
  action: 'clicked',
  component: CUSTOMER_PORTAL_COMPONENT.CLICKABLE_CARDS,
  customerGroup: guardDistributorValue(distributorId),
  customAttribute1: getAuthValue(isLoggedIn),
  customAttribute2: pageUrl,
  customAttribute3: targetUrl,
  customAttribute4: card,
});

export const onTrackClickableCardsClicked = (params: OnClickableCardsClickedEventProps) =>
  trackEvent(
    createClickableCardsClickedEvent(params),
    true,
    true,
    params.targetUrl,
    params.event,
    params.openInNewTab,
  );
